import(/* webpackMode: "eager" */ "/vercel/path0/apps/www/src/app/global-error.tsx");
